export default {
  addBatchNumber: '新增批次号',
  editBatchNumber: '编辑批次号',
  openBatchNumber: '启用批次号',
  cancelBatchNumber: '作废批次号',
  batchNumber: '批次号',
  planedQty: '计划件数',
  writeOffStatus: '状态',
  plantCode: '仓库',
  disableBatchNumberConfirmInfo: '确认作废该批次号？',
  errTitlePlannedQty: '计划件数错误',
  errMsgPlannedQty: '计划件数应为数字格式，请重新填写。',
  errTitleBatchNumberExist: '批次号重复存在',
  errMsgBatchNumberExist: '该批次号已存在',
  enterScan: '进入扫描',
  scanWarnFron: '注： 如批次号不存在在此下拉列表，请前往T-Hub配置页进行配置',
  nfcUid: 'NFC UID',
  reActive: '激活',
  back: '返回',
  confirm: '确认',
  noResponse: '环扣扫描无反应',
  noPhysicalBuckle: '商品无实物环扣',
  scanSuccess: '记录成功',
  undoSuccess: '撤回成功',
  uidCollectionUndoRecord: 'UID采集撤回记录',
  scanCount: '扫描次数',
  lastScan: '上次扫描',
  upc: 'UPC',
  undo: '撤回',
  undoDate: '撤回时间',
  undoSku: '撤回SKU',
  undoUpc: '撤回UPC',
  undoOperator: '操作人',
  createTime: '创建时间',
  updateTime: '更新时间',
  lastUpdate: '最后更新',
  lastUploadTime: '最后上传时间',
  lastUpdateTime: '最后更新时间',
  uploadDate: '上传日期',
  createDate: '创建日期',
  updateDate: '更新日期',
  plant: '仓库',
  error_code_2207: '批次处理状态必须为打开或正在扫描。',
  error_code_2208: 'T-Hub系统中不存在此NFC UID，无法收集。',
  error_code_2209_fon: '此NFC UID已在此批号',
  error_code_2209_bac: '下收集/提交并且不需要重新提交。',
  error_code_2210_fon: '此NFC UID已在另一个批号',
  error_code_2210_bac: '下收集/提交并且不需要重新提交。',
  error_code_2211: 'UPC无效，PLS再次扫描/输入。',
  positiveInteger: '计划数量应为正整数。',
  batchStatus: '批次状态',
  disableDate: '作废日期',
  scanDate: '扫描日期',
  disablementSubmitDate: '作废提交日期',
  scannedQty: '扫描件数',
  noNfcTagQty: '商品无实物环扣件数',
  scanNoResponseTagQty: '环扣扫描无反应件数',
  readableUidQty: '可读取环扣件数',
  readableActiveUidQty: '可读取环扣-有效件数',
  readableDisabledUidQty: '可读取环扣-已禁用件数',
  actualSubmitQty: '实际提交件数',
  uploadBtnMsg: '上 传 / 提交作废UID 清单',
  popOverMsgFon: '请注意上传的文件应包含”BatchNumber”与”NFC UID”两列，',
  popOverMsgBac: '其余列数据将被忽略。',
  taggedSku: '绑定 SKU',
  division: '产品分类',
  uidTaggingStatus: 'UID环扣绑定状态',
  uidStatusBefore: 'UID环扣状态（前）',
  uidStatusAfter: 'UID环扣状态（后）',
  excption: '特殊处理',
  sannerId: '扫描操作人',
  disablementSubmitter: '作废提交人',
  disableOperator: '作废操作人',
  detail: '明细',
  error_code_2212: '上传的文件应只包含”Batch Number”与”NFC UID”两列列名，请再次检查您的上传文件。',
  tBatchNumber: '批次号',
  batchNumberDnotExist: '不存在在系统中，请再次检查您的上传文件。',
  noScanBatch: '批次号',
  batchNumberNoScan: '扫描未完成，请先确认并点击“扫描完成”按钮，再进行上传。',
  batchNumberAlreadyCf: '已作废，不可再次提交。',
  tUid: 'UID ',
  noExitBatch: '不存在在系统中，请再次检查您的上传文件。',
  notInCurrentBatch: '未在指定批次号下提交，请再次检查您的上传文件。',
  noUidDataBatch: '下无NFC UID 数据，请再次检查您的上传文件。',
  error_code_2214: '批次号/UID不可为空，请再次检查您的上传文件。',
  spcWordMsg: '文件名不能包含以下特殊字符：\\/:*?"<>|',
  noBelongData: '在系统中属于其他仓库，请再次检查您的上传文件。',
  notTaggedUidQty: '未绑定环扣件数'
}
